import { type IWithValidate } from "@client/content/modules/Checkout/hooks";
import { type Checkout } from "@client/content/modules/Checkout/types";
import PargoPickup, { type PargoPickupAddress, type PargoPickupPoint } from "@common/components/Integrations/PargoPickup";
import { useI18n } from "@common/hooks/i18n";
import React from "react";

export type MapProps = {
  order: Checkout.Order;
  parameters: Checkout.IntegrationParameter[];
  shippingRule: Checkout.ShippingRule;
};

export type ActionProps = {
  onPickupPointChange: (data: PargoPickupPoint) => void;
};
const PargoPickupShippingMethod = React.forwardRef((props: ActionProps & MapProps, ref: React.RefObject<any>) => {
  const i18n = useI18n();

  const mapUrl = React.useMemo(() => props.parameters.find((x) => x.name === "PargoMapUrl")?.value, [props.parameters]);

  const address = React.useMemo(
    (): PargoPickupAddress => ({
      city: props.order.billingCity,
      postalCode: props.order.billingPostalCode,
      street: props.order.billingStreet,
      unit: props.order.billingUnit
    }),
    [props.order.billingCity, props.order.billingPostalCode, props.order.billingStreet, props.order.billingUnit]
  );

  React.useImperativeHandle<any, IWithValidate>(
    ref,
    () => ({
      validate: async () => {
        return props.order.pargoPickupPoint ? null : i18n.errorPargoPickupPointRequired;
      }
    }),
    [ref, props.order.pargoPickupPoint]
  );

  if (!mapUrl) return <div>Map url isn't set</div>;

  return (
    <PargoPickup
      address={address}
      mapUrl={mapUrl}
      onPickupPointChange={props.onPickupPointChange}
      value={props.order.pargoPickupPoint}
    />
  );
});

export default PargoPickupShippingMethod;
